import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full" }
const _hoisted_2 = { class: "absolute top-1 left-1 text-[10px]" }
const _hoisted_3 = { class: "rounded-lg shadow-lg border border-gray-300 sm:w-2/3 w-full" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center my-4 mx-6 justify-center"
}
const _hoisted_5 = {
  key: 1,
  class: "flex justify-around my-2 w-full"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-red-500" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  for: "email",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_10 = ["disabled", "required"]
const _hoisted_11 = {
  for: "telefono",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_12 = ["disabled", "required"]
const _hoisted_13 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_14 = {
  key: 1,
  class: "text-lg text-center underline"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  for: "email",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_17 = ["disabled", "required"]
const _hoisted_18 = {
  for: "telefono",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_19 = ["disabled", "required"]
const _hoisted_20 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_21 = {
  key: 1,
  class: "text-lg text-center underline"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "flex flex-row items-center justify-between w-[260px]" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  for: "email",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_26 = ["disabled", "required"]
const _hoisted_27 = {
  for: "telefono",
  class: "block text-sm font-medium text-primary-900"
}
const _hoisted_28 = ["disabled", "required"]
const _hoisted_29 = {
  key: 1,
  class: "text-red-500 col-span-3 text-center"
}
const _hoisted_30 = {
  key: 2,
  class: "col-span-3 text-center text-lg text-center underline"
}

import { ref, onMounted } from "vue";
import { useGeneralStore } from "../stores/general";
import { getCookie, setCookie, deleteCookie } from "../utils/cookies";
import { postMedicalBoothsUsersAffiliation } from "../utils/interfaces";
import GenericButton from "./ui/GenericButton.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import { scrollToInput, debounce } from "../utils/common";
import "@vuepic/vue-datepicker/dist/main.css";

interface PosibleTab {
  title: string;
  key: string;
  order: number;
  group: string;
}
const tabSelectedStyle = " text-primary-900 border-b-2 border-primary-900";
type AbreviacionEstado = keyof typeof abreviaturas;


export default /*@__PURE__*/_defineComponent({
  ...{ name: "BaseInformation" },
  __name: 'BaseInformation',
  emits: ["change-view", "pause-timer"],
  setup(__props, { emit: __emit }) {

const generalStore = useGeneralStore();


const emits = __emit;

const { booth } = generalStore;
const tabSelected = ref("personal");
const groupSelected = ref("");
const posibleGroup = ref([] as string[]);
const possibleTabs = ref([] as PosibleTab[]);
const loading = ref(false);
const errorMessage = ref("");
const sessionEmail = ref("");
const fechaNacimiento = ref();
const sexo = ref("");
const estado = ref("");
const nroOrden = ref();
const email = ref("");
const telefono = ref("");
const canContinue = ref(false);
const userData = ref();
const nombre = ref("");
const apaterno = ref("");
const amaterno = ref("");
const curp = ref("");
const detailMessage = ref("");
const anioNacimiento = ref();
const idRH = ref();
const detailsAnioNacimiento = ref("");

const abreviaturas: { [key: string]: string } = {
  AS: "AGUASCALIENTES",
  BC: "BAJA_CALIFORNIA",
  BS: "BAJA_CALIFORNIA_SUR",
  CC: "CAMPECHE",
  CL: "COAHUILA",
  CM: "COLIMA",
  CS: "CHIAPAS",
  CH: "CHIHUAHUA",
  DF: "CDMX",
  DG: "DURANGO",
  GT: "GUANAJUATO",
  GR: "GUERRERO",
  HG: "HIDALGO",
  JC: "JALISCO",
  MC: "ESTADO_DE_MEXICO",
  MN: "MICHOACAN",
  MS: "MORELOS",
  NT: "NAYARIT",
  NL: "NUEVO_LEON",
  OC: "OAXACA",
  PL: "PUEBLA",
  QT: "QUERETARO",
  QR: "QUINTANA_ROO",
  SP: "SAN_LUIS_POTOSI",
  SL: "SINALOA",
  SR: "SONORA",
  TC: "TABASCO",
  TS: "TAMAULIPAS",
  TL: "TLAXCALA",
  VZ: "VERACRUZ",
  YN: "YUCATAN",
  ZS: "ZACATECAS",
  NE: "NACIDO_EN_EL_EXTRANJERO",
};
function validarAnioNacimiento() {
  anioNacimiento.value = anioNacimiento.value?.toString().replace(/\D/g, "");
  const anioNum = Number(anioNacimiento.value);
  const anioActual = new Date().getFullYear();
  detailsAnioNacimiento.value = "";

  if (!Number.isInteger(anioNum)) {
    detailsAnioNacimiento.value = "Debe ingresar un número válido.";
    return false;
  }

  if (anioNacimiento.value?.toString().length !== 4) {
    detailsAnioNacimiento.value = "El año debe tener 4 dígitos.";
    return false;
  }

  if (anioNum < 1900) {
    detailsAnioNacimiento.value = "El año no puede ser menor a 1900.";
    return false;
  }

  if (anioNum > anioActual) {
    detailsAnioNacimiento.value = `El año no puede ser mayor al año actual (${anioActual}).`;
    return false;
  }
  return true;
}

function obtenerFechaNacimientoDesdeCURP(curp: string) {
  if (!curp || curp.length < 10) return null;

  const año = curp.substring(4, 6);
  const mes = curp.substring(6, 8);
  const dia = curp.substring(8, 10);

  // Determinar el siglo:
  // Si el año es mayor que el actual (por ejemplo, '99' cuando estamos en 2025), asumimos siglo XX.
  const añoNum = parseInt(año, 10);
  const añoActual = new Date().getFullYear() % 100;
  const siglo = añoNum <= añoActual ? 2000 : 1900;
  const añoCompleto = siglo + añoNum;

  // Crear objeto de fecha
  const fecha = new Date(`${añoCompleto}-${mes}-${dia}`);

  // Validar fecha
  if (isNaN(fecha.getTime())) return null;

  return fecha;
}

const validaTelefono = (telefono: string) => {
  const onlyNumbers = telefono.replace(/\D/g, "");
  const regex = /^[0-9]{10}$/;
  return onlyNumbers === "" || regex.test(onlyNumbers);
};

const validaEmail = (email: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

function getLastItemById(array: any[]) {
  return array.sort((a, b) => b.id - a.id)[0];
}

function cleanData() {
  userData.value = null;
  detailMessage.value = "";
  if (generalStore.booth?.tipo !== "TOTEM") {
    email.value = "";
    telefono.value = "";
  }
  canContinue.value = false;
}

async function validar(createIfNotExists = false) {
  loading.value = true;
  let body: postMedicalBoothsUsersAffiliation;
  cleanData();
  errorMessage.value = "";
  detailMessage.value = "";
  canContinue.value = false;

  if (!validaTelefono(telefono.value)) {
    errorMessage.value = "El campo teléfono debe tener 10 dígitos";
    loading.value = false;
    return;
  }
  let telefonoStr = telefono.value.replace(/\D/g, "");
  if (generalStore.booth?.tipo === "TOTEM") {
    if (!telefonoStr || !validaEmail(email.value)) {
      errorMessage.value = "Los campos teléfono y email son obligatorios";
      loading.value = false;
      return;
    }
  }
  let estadoCURP: AbreviacionEstado = "AS";
  if (tabSelected.value === "curp") {
    const booth = getCookie("booth") as string;
    if (!curp.value) {
      errorMessage.value = "El campo CURP es obligatorio";
      loading.value = false;
      return;
    }
    if (curp.value.length !== 18) {
      errorMessage.value = "El campo CURP debe tener 18 caracteres";
      loading.value = false;
      return;
    }
    const fechaNacimiento = obtenerFechaNacimientoDesdeCURP(curp.value);
    if (!fechaNacimiento) {
      errorMessage.value = "El campo CURP no es válido";
      loading.value = false;
      return;
    }
    const sexo = curp.value.substring(10, 11);
    const genero = sexo === "H" ? "MASCULINO" : "FEMENINO";
    estadoCURP = curp.value.substring(11, 13);
    body = {
      claveCabina: booth,
      fechaNacimiento: fechaNacimiento.toISOString(),
      genero: genero,
      curp: curp.value,
      telefono: telefonoStr,
      email: email.value,
    };
  } else if (tabSelected.value === "idEmpleadoAnio") {
    body = {
      claveCabina: getCookie("booth") as string,
      idRH: idRH.value,
      anioNacimiento: parseInt(anioNacimiento.value, 10),
    };
  } else {
    if (!fechaNacimiento.value || !sexo.value) {
      errorMessage.value = "Los campos marcados con * son obligatorios";
      loading.value = false;
      return;
    }
    const booth = getCookie("booth") as string;
    body = {
      claveCabina: booth,
      fechaNacimiento: fechaNacimiento.value.toISOString(),
      genero: sexo.value as "MASCULINO" | "FEMENINO",
      nombres: nombre.value,
      apellidoPaterno: apaterno.value,
      apellidoMaterno: amaterno.value,
      estado: estado.value,
      paisNacimiento: "México",
      telefono: telefonoStr,
      email: email.value,
    };
  }
  if (generalStore.booth?.solicitarNroOrden) {
    if (!nroOrden.value) {
      errorMessage.value = "El campo número de orden es obligatorio";
      loading.value = false;
      return;
    } else {
      body.nroOrden = nroOrden.value;
    }
  }
  const { idContratoCliente, idPlanCliente } = generalStore.booth;
  const hasClientBase = idContratoCliente && idPlanCliente;
  const query = {} as { onlySearch?: boolean };
  if (hasClientBase && !createIfNotExists) {
    query.onlySearch = true;
  }
  const res = (await generalStore.postMedicalBoothsAffiliation(
    body,
    query
  )) as any;
  if (res && res.afiliacion) {
    if (hasClientBase) {
      const numeroPlanAsociado = res.afiliacion.numeroPlanAsociado;
      const contratoPlanCliente = `${idContratoCliente}-${`${idPlanCliente}`.padStart(
        3,
        "0"
      )}-`;
      if (numeroPlanAsociado.startsWith(contratoPlanCliente)) {
        const hasNombreUsuario = res.afiliacion.afiliado.nombreUsuario;
        const nombreUsuarioIsEmail = validaEmail(hasNombreUsuario);
        const telefonoAfiliado = getLastItemById(
          res.afiliacion.afiliado.telefonos
        );
        if (telefonoAfiliado) {
          const newPhoneValue =
            hasNombreUsuario && !nombreUsuarioIsEmail
              ? hasNombreUsuario
              : telefonoAfiliado.numero;
          telefono.value = newPhoneValue.replace(/\D/g, "").slice(-10);
          telefonoStr = newPhoneValue.replace(/\D/g, "").slice(-10);
        }
        const emailAfiliado = getLastItemById(res.afiliacion.afiliado.emails);
        if (emailAfiliado) {
          const newEmailValue =
            hasNombreUsuario && nombreUsuarioIsEmail
              ? hasNombreUsuario
              : emailAfiliado.email;
          email.value = newEmailValue.trim();
        }
      } else {
        detailMessage.value =
          tabSelected.value === "idEmpleadoAnio"
            ? "Datos no encontrados, asegure que sus datos sean correctos o pruebe como invitado"
            : "No se encontró un expediente asociado al afiliado por lo que se creará uno nuevo";
      }
    }
    userData.value = {
      ...res,
      nroOrden: nroOrden.value,
      telefono: telefonoStr,
      email: email.value,
    };
    canContinue.value = true;
  } else {
    if (query.onlySearch) {
      detailMessage.value =
        tabSelected.value === "idEmpleadoAnio"
          ? "Datos no encontrados, asegure que sus datos sean correctos o pruebe como invitado"
          : "No se encontró un expediente asociado al afiliado por lo que se creará uno nuevo";
      if (tabSelected.value === "personal") {
        canContinue.value = true;
      }
    } else {
      errorMessage.value = res.message?.details;
    }
    if (tabSelected.value === "curp") {
      fechaNacimiento.value = obtenerFechaNacimientoDesdeCURP(curp.value);
      tabSelected.value = "personal";
      if (body.genero) {
        sexo.value = body.genero;
      }
      if (generalStore.booth?.solicitarNroOrden) {
        nroOrden.value = body.nroOrden;
      }
      if (abreviaturas[estadoCURP]) {
        estado.value = abreviaturas[estadoCURP];
      }
    }
  }
  loading.value = false;
}

async function handleClick() {
  if (!document || !document.exitFullscreen) return;
  await document.exitFullscreen();
}

const formatDate = (date: Date) => {
  if (!date) return "";
  const day = date.getDate();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

async function changeView(e: Event) {
  e.preventDefault();
  if (canContinue.value) {
    const idPersona = userData.value?.afiliacion?.idPersona;
    if (!idPersona) {
      await validar(true);
    } else {
      const promises = [];
      const existPhoneNumber =
        userData.value.afiliacion?.afiliado?.telefonos?.some(
          (phone: any) => phone.numero.replace(/\D/g, "") === telefono.value
        );
      if (!existPhoneNumber) {
        promises.push(
          generalStore.addPhoneToPerson(idPersona, {
            numero: `521${telefono.value}`,
            tipoTelefono: "PARTICULAR",
            tipoLinea: "CELULAR",
            tieneWA: false,
          })
        );
      }
      const existEmail = userData.value.afiliacion?.afiliado?.emails?.some(
        (item: any) => item.email === email.value
      );
      if (!existEmail) {
        promises.push(
          generalStore.addEmailToPerson(idPersona, {
            email: email.value,
            tipoEmail: "PARTICULAR",
          })
        );
      }
      await Promise.allSettled(promises);
    }
    userData.value = {
      ...userData.value,
      email: email.value,
    };
    emits("change-view", "showServices", userData.value);
  }
}

const tryValidate = debounce(() => {
  if (generalStore.booth?.tipo === "TOTEM") {
    if (!email.value || !telefono.value) return;
  }
  if (tabSelected.value === "curp") {
    if (curp.value.length !== 18) return;
  } else if (tabSelected.value === "personal") {
    if (
      !nombre.value ||
      !apaterno.value ||
      !amaterno.value ||
      !fechaNacimiento.value ||
      !sexo.value
    )
      return;
  } else if (tabSelected.value === "idEmpleadoAnio") {
    if (!anioNacimiento.value || !idRH.value || !validarAnioNacimiento())
      return;
  }
  validar();
}, 1000);

const groupName = {
  colaborador: "Soy Colaborador",
  posibleInvitado: "Soy Invitado",
} as Record<string, string>;

const handleChangeGroup = (group: string) => {
  groupSelected.value = group;
  tabSelected.value = possibleTabs.value.filter(
    (f) => f.group === group
  )[0].key;
  cleanData();
};

onMounted(() => {
  emits("pause-timer");
  possibleTabs.value = [];
  Object.entries(generalStore.getBooth.customConfig?.tipoValidacion).forEach(
    ([key, value]) => {
      if (value) {
        switch (key) {
          case "datosPersonales":
            possibleTabs.value.push({
              title: "Datos Personales",
              key: "personal",
              order: 2,
              group: "posibleInvitado",
            });
            break;
          case "curp":
            possibleTabs.value.push({
              title: "CURP",
              key: "curp",
              order: 3,
              group: "posibleInvitado",
            });
            break;
          case "idEmpleadoAnio":
            possibleTabs.value.push({
              title: "Soy Colaborador",
              key: "idEmpleadoAnio",
              order: 1,
              group: "colaborador",
            });
            break;
        }
      }
    }
  );

  possibleTabs.value.sort((a, b) => a.order - b.order);
  tabSelected.value = possibleTabs.value[0].key;
  posibleGroup.value = [];
  possibleTabs.value.forEach(({ group }) => {
    if (!posibleGroup.value.includes(group)) {
      posibleGroup.value.push(group);
    }
  });
  groupSelected.value = posibleGroup.value[0];
  const booth = getCookie("booth") as string;
  const fingerprint = getCookie("fingerprint") as string;
  generalStore.getSession().then((session: any) => {
    const accessToken = session.tokens?.accessToken as object;
    sessionEmail.value = session.tokens?.signInDetails?.loginId?.split("@")[0];
    if (!booth) {
      emits("change-view", "setBoothKey");
      return;
    }
    if (!fingerprint) {
      emits("change-view", "login");
      return;
    }
    const days = generalStore.getBooth.customConfig?.duracionSesion;
    setCookie("booth", booth, days);
    setCookie("fingerprint", fingerprint, days);
    generalStore
      .postMedicalBoothsValidation({
        claveCabina: booth,
        fingerprint: fingerprint,
        accessToken: accessToken,
      })
      .then((res: any) => {
        if (res.code !== 200) {
          const { idSesion } = res.message;
          if (idSesion) {
            generalStore.deleteBoothSession(idSesion);
          }
          deleteCookie("booth");
          deleteCookie("fingerprint");
          emits("change-view", "setBoothKey");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(sessionEmail.value), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(booth).nombre), 1)
    ]),
    _createVNode(GenericButton, {
      variant: "ghost",
      onClick: handleClick,
      class: "absolute top-0 right-0"
    }, {
      default: _withCtx(() => _cache[44] || (_cache[44] = [
        _createTextVNode(" Salir ")
      ])),
      _: 1,
      __: [44]
    }),
    _createElementVNode("div", _hoisted_3, [
      _cache[64] || (_cache[64] = _createElementVNode("h1", {
        id: "titulo",
        class: "text-2xl text-primary-900 font-bold p-4 pb-0"
      }, " Registro para aplicar estudios ", -1)),
      _cache[65] || (_cache[65] = _createElementVNode("hr", { class: "my-4 border-gray-200" }, null, -1)),
      _cache[66] || (_cache[66] = _createElementVNode("p", { class: "text-center" }, "Por favor, selecciona el método de registro:", -1)),
      (_unref(booth)?.idContratoCliente)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[45] || (_cache[45] = [
            _createElementVNode("div", { class: "text-sm font-bold" }, [
              _createElementVNode("p", null, "Por favor, asegúrate de ingresar correctamente todos tus datos."),
              _createElementVNode("p", null, " Esto nos permitirá identificar tu expediente o generar uno nuevo si aún no cuentas con él. ")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (posibleGroup.value.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posibleGroup.value, (group) => {
              return (_openBlock(), _createBlock(GenericButton, {
                key: group,
                variant: groupSelected.value === group ? 'secondary' : 'outline',
                class: "px-2! py-1!",
                onClick: ($event: any) => (handleChangeGroup(group))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(groupName[group]), 1)
                ]),
                _: 2
              }, 1032, ["variant", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (possibleTabs.value.filter((f) => f.group === groupSelected.value).length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["grid mb-4", {
          'grid-cols-2!':
            possibleTabs.value.filter((f) => f.group === groupSelected.value).length === 2,
          'grid-cols-3!':
            possibleTabs.value.filter((f) => f.group === groupSelected.value).length === 3,
        }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(possibleTabs.value.filter(
            (f) => f.group === groupSelected.value
          ), (possibleTab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: possibleTab.key,
                class: _normalizeClass(
            'text-gray-600 py-4 px-6 block hover:text-primary focus:outline-none cursor-pointer' +
            (tabSelected.value === possibleTab.key ? tabSelectedStyle : '')
          ),
                onClick: ($event: any) => (tabSelected.value = possibleTab.key)
              }, _toDisplayString(possibleTab.title), 11, _hoisted_6))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (tabSelected.value === 'idEmpleadoAnio')
        ? (_openBlock(), _createElementBlock("form", {
            key: 3,
            class: "flex flex-col items-center gap-3 p-4 pt-0",
            onSubmit: changeView,
            novalidate: ""
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid-cols-1 md:grid-cols-2 gap-3 w-full", { 'grid-cols-3!': _unref(generalStore).booth?.solicitarNroOrden }])
            }, [
              _createElementVNode("div", null, [
                _cache[46] || (_cache[46] = _createElementVNode("label", {
                  for: "curp",
                  class: "block text-sm font-medium text-primary-900"
                }, "Número de empleado *", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                  id: "idRH",
                  name: "idRH",
                  type: "text",
                  maxlength: "18",
                  autocomplete: "off",
                  placeholder: "XXXXXXXXXX",
                  class: "w-full border border-gray-300 rounded p-2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((idRH).value = $event)),
                  required: ""
                }, null, 544), [
                  [_vModelText, idRH.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[47] || (_cache[47] = _createElementVNode("label", {
                  for: "email",
                  class: "block text-sm font-medium text-primary-900"
                }, " Año de Nacimiento * ", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                  class: "w-full border border-gray-300 rounded p-2",
                  type: "number",
                  id: "anioNacimiento",
                  name: "anioNacimiento",
                  placeholder: "XXXX",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((anioNacimiento).value = $event)),
                  required: "",
                  min: "1900",
                  onBlur: validarAnioNacimiento
                }, null, 544), [
                  [_vModelText, anioNacimiento.value]
                ]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(detailsAnioNacimiento.value), 1)
              ]),
              (_unref(generalStore).booth?.solicitarNroOrden)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", {
                      for: "nroOrden",
                      class: "block text-sm font-medium text-primary-900"
                    }, "Número de orden *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                      class: "w-full border border-gray-300 rounded p-2",
                      type: "text",
                      id: "nroOrden",
                      name: "nroOrden",
                      placeholder: "XXXXXX",
                      autocomplete: "off",
                      required: "",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((nroOrden).value = $event))
                    }, null, 544), [
                      [_vModelText, nroOrden.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_9, " Correo Electrónico " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  class: "w-full border border-gray-300 rounded p-2",
                  type: "email",
                  id: "email",
                  name: "email",
                  placeholder: "correo@ejemplo.com",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((email).value = $event)),
                  disabled: !canContinue.value,
                  required: _unref(generalStore).booth?.tipo === 'TOTEM'
                }, null, 40, _hoisted_10), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_11, " Teléfono " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  class: "w-full border border-gray-300 rounded p-2",
                  type: "tel",
                  id: "telefono",
                  name: "telefono",
                  pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
                  placeholder: "(XXX) XXX-XXXX",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((telefono).value = $event)),
                  disabled: !canContinue.value,
                  required: _unref(generalStore).booth?.tipo === 'TOTEM'
                }, null, 40, _hoisted_12), [
                  [_vModelText, telefono.value]
                ])
              ])
            ], 2),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            (detailMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(detailMessage.value), 1))
              : _createCommentVNode("", true),
            _createVNode(GenericButton, {
              type: "submit",
              loading: loading.value,
              disabled: !canContinue.value,
              class: "w-full"
            }, {
              default: _withCtx(() => _cache[49] || (_cache[49] = [
                _createTextVNode(" Continuar ")
              ])),
              _: 1,
              __: [49]
            }, 8, ["loading", "disabled"])
          ], 32))
        : _createCommentVNode("", true),
      (tabSelected.value === 'curp')
        ? (_openBlock(), _createElementBlock("form", {
            key: 4,
            class: "flex flex-col items-center gap-3 p-4 pt-0",
            onSubmit: changeView,
            novalidate: ""
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid-cols-2 gap-3 w-full", { 'grid-cols-3!': !_unref(generalStore).booth?.solicitarNroOrden }])
            }, [
              _createElementVNode("div", null, [
                _cache[50] || (_cache[50] = _createElementVNode("label", {
                  for: "curp",
                  class: "block text-sm font-medium text-primary-900"
                }, "CURP *", -1)),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  id: "curp",
                  name: "curp",
                  type: "text",
                  maxlength: "18",
                  autocomplete: "off",
                  placeholder: "XXXX000000XXXXXX00",
                  style: {"text-transform":"uppercase"},
                  class: "w-full border border-gray-300 rounded p-2",
                  required: "",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((curp).value = $event)),
                  onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                  "onVModel:update": _cache[15] || (_cache[15] = (e) => (curp.value = e.toUpperCase()))
                }, null, 544), [
                  [_vModelText, curp.value]
                ])
              ]),
              (_unref(generalStore).booth?.solicitarNroOrden)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[51] || (_cache[51] = _createElementVNode("label", {
                      for: "nroOrden",
                      class: "block text-sm font-medium text-primary-900"
                    }, "Número de orden *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      onFocus: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                      class: "w-full border border-gray-300 rounded p-2",
                      type: "text",
                      id: "nroOrden",
                      name: "nroOrden",
                      placeholder: "XXXXXX",
                      autocomplete: "off",
                      required: "",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((nroOrden).value = $event))
                    }, null, 544), [
                      [_vModelText, nroOrden.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_16, " Correo Electrónico " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  class: "w-full border border-gray-300 rounded p-2",
                  type: "email",
                  id: "email",
                  name: "email",
                  placeholder: "correo@ejemplo.com",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((email).value = $event)),
                  disabled: !canContinue.value,
                  required: _unref(generalStore).booth?.tipo === 'TOTEM'
                }, null, 40, _hoisted_17), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_18, " Teléfono " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
                _withDirectives(_createElementVNode("input", {
                  onFocus: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                  class: "w-full border border-gray-300 rounded p-2",
                  type: "tel",
                  id: "telefono",
                  name: "telefono",
                  pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
                  placeholder: "(XXX) XXX-XXXX",
                  autocomplete: "off",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((telefono).value = $event)),
                  disabled: !canContinue.value,
                  required: _unref(generalStore).booth?.tipo === 'TOTEM'
                }, null, 40, _hoisted_19), [
                  [_vModelText, telefono.value]
                ])
              ])
            ], 2),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            (detailMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(detailMessage.value), 1))
              : _createCommentVNode("", true),
            _createVNode(GenericButton, {
              type: "submit",
              loading: loading.value,
              disabled: !canContinue.value,
              class: "w-full"
            }, {
              default: _withCtx(() => _cache[52] || (_cache[52] = [
                _createTextVNode(" Continuar ")
              ])),
              _: 1,
              __: [52]
            }, 8, ["loading", "disabled"])
          ], 32))
        : _createCommentVNode("", true),
      (tabSelected.value === 'personal')
        ? (_openBlock(), _createElementBlock("form", {
            key: 5,
            class: "grid grid-cols-3 gap-3 p-4 pt-0",
            onSubmit: changeView,
            novalidate: ""
          }, [
            (_unref(generalStore).booth?.solicitarNroOrden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _cache[53] || (_cache[53] = _createElementVNode("label", {
                    for: "nroOrden",
                    class: "block text-sm font-medium text-primary-900"
                  }, "Número de orden *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    onFocus: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                    onInput: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                    class: "w-full border border-gray-300 rounded p-2",
                    type: "text",
                    id: "nroOrden",
                    name: "nroOrden",
                    placeholder: "XXXXXX",
                    autocomplete: "off",
                    required: "",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((nroOrden).value = $event))
                  }, null, 544), [
                    [_vModelText, nroOrden.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _cache[54] || (_cache[54] = _createElementVNode("label", {
                for: "nombre",
                class: "block text-sm font-medium text-primary-900"
              }, "Nombre *", -1)),
              _withDirectives(_createElementVNode("input", {
                onFocus: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                onInput: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                class: "w-full border border-gray-300 rounded p-2",
                type: "text",
                id: "nombre",
                name: "nombre",
                placeholder: "Tu nombre",
                autocomplete: "off",
                required: "",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((nombre).value = $event))
              }, null, 544), [
                [_vModelText, nombre.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[55] || (_cache[55] = _createElementVNode("label", {
                for: "apaterno",
                class: "block text-sm font-medium text-primary-900"
              }, "Apellido Paterno *", -1)),
              _withDirectives(_createElementVNode("input", {
                onFocus: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                onInput: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                class: "w-full border border-gray-300 rounded p-2",
                type: "text",
                id: "apaterno",
                name: "apaterno",
                placeholder: "Tu apellido paterno",
                autocomplete: "off",
                required: "",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((apaterno).value = $event))
              }, null, 544), [
                [_vModelText, apaterno.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[56] || (_cache[56] = _createElementVNode("label", {
                for: "amaterno",
                class: "block text-sm font-medium text-primary-900"
              }, "Apellido Materno *", -1)),
              _withDirectives(_createElementVNode("input", {
                onFocus: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                onInput: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                class: "w-full border border-gray-300 rounded p-2",
                type: "text",
                id: "amaterno",
                name: "amaterno",
                placeholder: "Tu apellido materno",
                autocomplete: "off",
                required: "",
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((amaterno).value = $event))
              }, null, 544), [
                [_vModelText, amaterno.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[58] || (_cache[58] = _createElementVNode("label", {
                for: "estado",
                class: "block text-sm font-medium text-primary-900"
              }, "Lugar de Nacimiento *", -1)),
              _withDirectives(_createElementVNode("select", {
                name: "estado",
                id: "estado",
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((estado).value = $event)),
                onInput: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args))),
                class: "w-full border border-gray-300 rounded p-2"
              }, _cache[57] || (_cache[57] = [
                _createStaticVNode("<option value=\"\" disabled selected>Lugar de nacimiento</option><option value=\"NO_ESPECIFICADO\">Extranjero</option><option value=\"AGUASCALIENTES\">Aguascalientes</option><option value=\"BAJA_CALIFORNIA\">Baja California</option><option value=\"BAJA_CALIFORNIA_SUR\">Baja California Sur</option><option value=\"CAMPECHE\">Campeche</option><option value=\"COAHUILA\">Coahuila</option><option value=\"COLIMA\">Colima</option><option value=\"CHIAPAS\">Chiapas</option><option value=\"CHIHUAHUA\">Chihuahua</option><option value=\"CDMX\">Ciudad de México</option><option value=\"GUANAJUATO\">Guanajuato</option><option value=\"GUERRERO\">Guerrero</option><option value=\"HIDALGO\">Hidalgo</option><option value=\"JALISCO\">Jalisco</option><option value=\"ESTADO_DE_MEXICO\">Estado de México</option><option value=\"MICHOACAN\">Michoacán</option><option value=\"MORELOS\">Morelos</option><option value=\"NAYARIT\">Nayarit</option><option value=\"NUEVO_LEON\">Nuevo León</option><option value=\"OAXACA\">Oaxaca</option><option value=\"PUEBLA\">Puebla</option><option value=\"QUERETARO\">Querétaro</option><option value=\"QUINTANA_ROO\">Quintana Roo</option><option value=\"SAN_LUIS_POTOSI\">San Luis Potosí</option><option value=\"SINALOA\">Sinaloa</option><option value=\"SONORA\">Sonora</option><option value=\"TABASCO\">Tabasco</option><option value=\"TAMAULIPAS\">Tamaulipas</option><option value=\"TLAXCALA\">Tlaxcala</option><option value=\"VERACRUZ\">Veracruz</option><option value=\"YUCATAN\">Yucatán</option><option value=\"ZACATECAS\">Zacatecas</option>", 33)
              ]), 544), [
                [_vModelSelect, estado.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[60] || (_cache[60] = _createElementVNode("label", {
                for: "fechaNacimiento",
                class: "block text-sm font-medium text-primary-900"
              }, "Fecha de Nacimiento *", -1)),
              _createVNode(_unref(VueDatePicker), {
                modelValue: fechaNacimiento.value,
                "onUpdate:modelValue": [
                  _cache[36] || (_cache[36] = ($event: any) => ((fechaNacimiento).value = $event)),
                  _cache[37] || (_cache[37] = ($event: any) => (_unref(tryValidate)()))
                ],
                locale: "es",
                timezone: "UTC",
                format: formatDate,
                "max-date": new Date()
              }, {
                "time-picker": _withCtx(() => _cache[59] || (_cache[59] = [])),
                "action-row": _withCtx(({ internalModelValue, selectDate }) => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", null, _toDisplayString(formatDate(internalModelValue as Date)), 1),
                    _createElementVNode("button", {
                      class: "bg-primary text-white p-1 px-2 rounded",
                      onClick: selectDate
                    }, " Aceptar ", 8, _hoisted_24)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "max-date"])
            ]),
            _createElementVNode("div", null, [
              _cache[62] || (_cache[62] = _createElementVNode("label", {
                for: "sexo",
                class: "block text-sm font-medium text-primary-900"
              }, "Sexo *", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((sexo).value = $event)),
                class: "w-full border border-gray-300 rounded p-2",
                id: "sexo",
                name: "sexo",
                required: "",
                onInput: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_unref(tryValidate) && _unref(tryValidate)(...args)))
              }, _cache[61] || (_cache[61] = [
                _createElementVNode("option", {
                  value: "",
                  disabled: "",
                  selected: ""
                }, "Sexo", -1),
                _createElementVNode("option", { value: "FEMENINO" }, "Femenino", -1),
                _createElementVNode("option", { value: "MASCULINO" }, "Masculino", -1)
              ]), 544), [
                [_vModelSelect, sexo.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_25, " Correo Electrónico " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
              _withDirectives(_createElementVNode("input", {
                onFocus: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                class: "w-full border border-gray-300 rounded p-2",
                type: "email",
                id: "email",
                name: "email",
                placeholder: "correo@ejemplo.com",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((email).value = $event)),
                disabled: !canContinue.value,
                required: _unref(generalStore).booth?.tipo === 'TOTEM'
              }, null, 40, _hoisted_26), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_27, " Teléfono " + _toDisplayString(_unref(generalStore).booth?.tipo === "TOTEM" ? "*" : ""), 1),
              _withDirectives(_createElementVNode("input", {
                onFocus: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_unref(scrollToInput) && _unref(scrollToInput)(...args))),
                class: "w-full border border-gray-300 rounded p-2",
                type: "tel",
                id: "telefono",
                name: "telefono",
                pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
                placeholder: "(XXX) XXX-XXXX",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((telefono).value = $event)),
                disabled: !canContinue.value,
                required: _unref(generalStore).booth?.tipo === 'TOTEM'
              }, null, 40, _hoisted_28), [
                [_vModelText, telefono.value]
              ])
            ]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            (detailMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(detailMessage.value), 1))
              : _createCommentVNode("", true),
            _createVNode(GenericButton, {
              loading: loading.value,
              disabled: !canContinue.value,
              class: "col-span-3",
              type: "submit"
            }, {
              default: _withCtx(() => _cache[63] || (_cache[63] = [
                _createTextVNode(" Continuar ")
              ])),
              _: 1,
              __: [63]
            }, 8, ["loading", "disabled"])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})